<template>
	<div>
		<div class="form-bar">
			<el-form :inline="true">
				<el-form-item label="时间范围">
					<DateRange v-model="timeSectionList" />
				</el-form-item>
				<el-form-item label="车间选择">
					<Workshop v-model="workshop"></Workshop>
				</el-form-item>
				<el-form-item label="机台选择">
					<el-select v-model="jtList" multiple placeholder="请选择">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"> </el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="Statistics">统计</el-button>
				</el-form-item>
			</el-form>
		</div>
		<div>
			<ve-histogram v-loading="loading" :data="chartData" height="350px"></ve-histogram>
		</div>
	</div>
</template>

<script>
	import { getOutputOfDevice, getYieldOfDevice } from '@/service/reportService'
	import Workshop from '@/components/WorkshopSelect'
	import jtService from '@/service/jtService'
	import DateRange from '@/components/DateRangePicker'
	export default {
		components: {
			Workshop,
			DateRange,
		},
		data() {
			return {
				showDeviceInfo: false,
				selectedJT: {},
				chartData: { columns: [], rows: [] },
				loading: false,
				timeSectionList: [],
				options: [],
				workshop: '5eeaf0f9f9d2628d3c8d83d2',
				jtList: [],
			}
		},
		methods: {
			async getData() {
				this.loading = true
				var jtOutputReport = await getOutputOfDevice(this.jtList, [{ startTime: new Date(this.timeSectionList[0]).getTime(), endTime: new Date(this.timeSectionList[1]).getTime() }])
				console.log('tOutputReport11')
				console.log(jtOutputReport)
				// var jtYieldReport = await getYieldOfDevice(this.jtList,[{startTime: new Date(this.timeSectionList[0]).getTime(), endTime:  new Date(this.timeSectionList[1]).getTime()}])
				// console.log("jtYieldReport")
				// console.log(xsjtYieldReport)
				this.chartData.columns = ['机台', '产量', '良率']
				this.chartData.rows = []

				for (let index = 0; index < this.jtList.length; index++) {
					this.chartData.rows.push({ 机台: this.options.filter(t => t.id == this.jtList[index])[0].name, 产量: jtOutputReport[index][0], 良率: 0 })
				}
				console.log(this.chartData)
				this.loading = false
			},
			async getjtData() {
				jtService.getDeviceStatusList(1, 20, { jt_id: '', workshop_id: this.workshop }).then(res => {
					var newList = []
					var techParamsTask = []

					this.options = res.data
					console.log(res.data)
				})
			},
			async Statistics() {
				console.log(this.jtList)
				await this.getData()
			},
		},
		watch: {
			workshop(newVal) {
				;(this.jtList = []), this.getjtData()
			},
		},
		async created() {
			await this.getjtData()
		},
	}
</script>

<style scoped></style>
